import service from "services/service";

export const getServiceMonitorService = () => (
  service('get', `v3/servicios/monitor`)
)

export const getServiceMonitorHistorialService = (code) => (
  service('get', `v3/servicios/${code}/historial`)
)
